import React from 'react';

interface StatWidgetProps {
  value: string | number;
  label: string;
  change?: string;
  changePositive?: boolean;
}

const StatWidget: React.FC<StatWidgetProps> = ({ value, label, change, changePositive = true }) => (
  <div
    style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      padding: 18,
    }}
  >
    <div
      style={{
        fontSize: 'clamp(1.4rem, 4vw, 1.8rem)',
        fontWeight: 800,
        fontFamily: 'var(--font-mono)',
        color: 'var(--accent)',
      }}
    >
      {value}
    </div>
    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4, fontWeight: 600 }}>
      {label}
    </div>
    {change && (
      <div
        style={{
          fontSize: '0.7rem',
          color: changePositive ? 'var(--success)' : 'var(--error)',
          marginTop: 6,
          fontWeight: 700,
        }}
      >
        {change}
      </div>
    )}
  </div>
);

export default StatWidget;
